export var TypeText;
(function (TypeText) {
    TypeText["COLOR"] = "color";
    TypeText["DATE"] = "date";
    TypeText["DATE_TIME_LOCAL"] = "datetime-local";
    TypeText["EMAIL"] = "email";
    TypeText["MONTH"] = "month";
    TypeText["NUMBER"] = "number";
    TypeText["PASSWORD"] = "password";
    TypeText["RANGE"] = "range";
    TypeText["SEARCH"] = "search";
    TypeText["TEL"] = "tel";
    TypeText["TEXT"] = "text";
    TypeText["TIME"] = "time";
    TypeText["WEEK"] = "week";
})(TypeText || (TypeText = {}));
//# sourceMappingURL=type-text.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/text/type-text.js
// module id = 167
// module chunks = 14